module.exports = __webpack_public_path__ + "img/CLOSED_ORANGE.fe3f7c7b.svg";